"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTypeToggle = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const mobileIcon_svg_1 = __importDefault(require("../../../assets/icons/mobileIcon.svg"));
const pin_svg_1 = __importDefault(require("../../../assets/icons/pin.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const thresholdSlice_1 = require("../../../store/thresholdSlice");
const filters_1 = require("../../../types/filters");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const FilterInfoPopup_1 = require("./FilterInfoPopup");
const S = __importStar(require("./SessionFilters.style"));
const SessionTypeToggle = () => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { searchParams, sessionType, updateSessionType } = (0, mapParamsHandler_1.useMapParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleClick = (0, react_1.useCallback)((type) => {
        dispatch((0, thresholdSlice_1.resetUserThresholds)());
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
        dispatch((0, sessionFiltersSlice_1.setCustomParametersModalOpen)(false));
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false));
        dispatch((0, sessionFiltersSlice_1.setCustomSensorsModalOpen)(false));
        updateSessionType(type);
        dispatch((0, mapSlice_1.setFetchingData)(true));
        dispatch((0, sessionFiltersSlice_1.setFixedSessionsType)(sessionFiltersSlice_1.FixedSessionsTypes.ACTIVE));
    }, [dispatch, searchParams, updateSessionType]);
    return (react_1.default.createElement(S.SingleFilterWrapper, null,
        react_1.default.createElement(S.SessionToggleWrapper, null,
            react_1.default.createElement(S.Tab, { "$isActive": sessionType === filters_1.SessionTypes.MOBILE, onClick: () => handleClick(filters_1.SessionTypes.MOBILE) },
                t("filters.mobileSessions"),
                react_1.default.createElement(S.IconWrapper, { "$src": mobileIcon_svg_1.default, "$isActive": sessionType === filters_1.SessionTypes.MOBILE })),
            react_1.default.createElement(S.Tab, { "$isActive": sessionType === filters_1.SessionTypes.FIXED, onClick: () => handleClick(filters_1.SessionTypes.FIXED) },
                t("filters.fixedSessions"),
                react_1.default.createElement(S.IconWrapper, { "$src": pin_svg_1.default, "$isActive": sessionType === filters_1.SessionTypes.FIXED }))),
        react_1.default.createElement(FilterInfoPopup_1.FilterInfoPopup, { filterTranslationLabel: "filters.mobileFixedInfo" })));
};
exports.SessionTypeToggle = SessionTypeToggle;
